import * as React from 'react';
import { connect } from 'react-redux';
import '../SuperUser/css/SuperUserPageView.css';
import { getScrollbarWidth } from '../../lib/helpers';
import { ISeedCategory } from '../../infrastructure/interfaces'
import { getSeedCategories, downloadTechSheetZip } from '../../actions/actions'
import HeaderBar from '../HeaderBar/HeaderBar';
import {TooltipCont} from "../../infrastructure/tooltips";

export interface IBatchDownloadTechSheetsProps {
    seedCategories?: ISeedCategory[];
    getSeedCategories(): void;
    downloadTechSheetZip(category: ISeedCategory): void;
    onCreate(): void;
}

export interface IBatchDownloadTechSheetsState {
}

const mapStateToProps = (state: any) => {
    return {
        seedCategories: state.seedCategoryList,
    };
};

const mapDispatchToProps = (dispatch: any): any => {
    return {
        getSeedCategories: () => {
            dispatch(getSeedCategories());
        },
        downloadTechSheetZip: (category: ISeedCategory) => {
            dispatch(downloadTechSheetZip(category.name));
        }
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageSeedDividersTable extends React.Component<IBatchDownloadTechSheetsProps, IBatchDownloadTechSheetsState> {
    tableRow: HTMLElement;
    constructor(props: IBatchDownloadTechSheetsProps) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.getSeedCategories();
    }

    onDownloadCategory(category: ISeedCategory) {
        this.props.downloadTechSheetZip(category);
    }

    render() {

        const {
            seedCategories,
        } = this.props;
        const nonNullSeedCategories = seedCategories ? seedCategories : [];

        return (
            <div className="root-container">
                <HeaderBar />
                <div className="inner-su-container">
                    <div className="manage-items-row">
                        <div className="in-row-text-container">
                            Batch Download Tech Sheets
                        </div>
                    </div>
                    <table className="table-scrollable documents-table">
                        <thead style={{ paddingRight: getScrollbarWidth() }}>
                            <tr>
                                <th>Name</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="document-table-body">
                            {nonNullSeedCategories.map((t: ISeedCategory) =>

                            <tr key={t.id} ref={tr => this.tableRow = tr!}>
                                <td>
                                    {t.name}
                                </td>
                                <td>
                                    <div>
                                        <button
                                            className="btn primary-green"
                                            onClick={() => {
                                                this.onDownloadCategory(t)
                                            }}
                                            title={TooltipCont.BATCH_DOWNLOAD}
                                            disabled={false}
                                        >
                                             Download All
                                        </button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BatchDownloads/BatchDownloadTechSheets.tsx